import script from "./psiStockGoods.vue?vue&type=script&setup=true&lang=js"
export * from "./psiStockGoods.vue?vue&type=script&setup=true&lang=js"

import "./psiStockGoods.vue?vue&type=style&index=0&id=620942ca&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-620942ca"]])

export default __exports__